export const ETHSVG = (
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.304 8.5386L9.10616 7.5311L11.304 6.5236C11.3876 6.48528 11.4473 6.41848 11.4672 6.34082C11.4874 6.26304 11.4661 6.18193 11.4088 6.1182L6.06774 0.175625C6.02008 0.0730609 5.90113 0 5.76119 0C5.71307 0 5.66754 0.008941 5.62631 0.0245236C5.56991 0.0411281 5.5184 0.068591 5.48101 0.109974L0.0814937 6.11827C0.0243241 6.18175 0.00301748 6.26311 0.0230954 6.34077C0.0430208 6.41843 0.102795 6.48523 0.186332 6.52355L2.38412 7.53104L0.235852 8.51555C0.155382 8.53535 0.0842634 8.58031 0.0405799 8.6466C-0.0385078 8.76654 0.00195583 8.91381 0.127642 8.99503L5.42239 14.8872C5.47037 14.9896 5.58916 15.0624 5.72894 15.0624C5.73185 15.0624 5.73445 15.0616 5.73752 15.0616C5.73997 15.0616 5.74243 15.0624 5.74472 15.0624C5.84864 15.0624 5.94628 15.0215 6.00836 14.9523L11.4087 8.94364C11.466 8.87991 11.4871 8.7988 11.4671 8.72101C11.4471 8.64348 11.3875 8.57694 11.3038 8.53849L11.304 8.5386ZM5.39945 13.9456L1.53605 9.64641L5.39945 11.4179V13.9456ZM6.05852 11.4177L9.97678 9.62123L6.05852 13.9809V11.4177ZM8.26444 7.29021C8.26397 7.29021 8.26382 7.29034 8.26351 7.29034L6.09103 8.28623L6.09042 1.11715L10.6542 6.19452L8.26444 7.29021ZM5.4315 1.08148L5.43166 8.30124L3.22684 7.29028C3.22638 7.29015 3.22577 7.29015 3.22531 7.28976L0.836392 6.19451L5.4315 1.08148ZM5.58646 8.99902C5.63826 9.02278 5.6959 9.03351 5.75306 9.03235C5.75598 9.03235 5.75858 9.03312 5.76166 9.03312C5.84258 9.03312 5.91569 9.00783 5.97286 8.96772L8.42263 7.84448L10.4533 8.77562L5.72911 10.9415L1.02136 8.78275L3.06816 7.84448L5.58646 8.99902Z"
      fill="currentColor"
    />
  </svg>
);

export const DiscordSVG = (
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.8465 3.44751C26.3844 1.37867 19.3856 -0.724916 18.7509 0.244365C18.968 0.838441 22.2345 0.966983 25.3061 3.38324C22.409 1.62359 17.9194 1.12332 15.7238 0.98088L14.9926 0.946139H14.9815L14.2669 0.98088C12.0713 1.12332 7.5855 1.62359 4.68837 3.38324C7.75996 0.966983 11.0301 0.836704 11.2454 0.242628C10.6107 -0.724916 3.61563 1.37693 3.15164 3.44577C3.15164 3.44577 -0.499006 10.1074 0.0577788 16.4685C2.21996 19.3607 6.7893 20.231 8.02351 19.9427C9.25957 18.4957 9.43959 18.0892 9.43959 18.0892C9.43959 18.0892 5.98568 16.7586 5.12823 15.2839C6.96376 16.1923 8.64154 17.7852 14.2094 17.9589H15.6941C21.262 17.7852 22.9899 16.1923 24.8254 15.2839C23.9661 16.7586 20.553 18.0996 20.553 18.0996C20.553 18.0996 20.7367 18.5009 21.9747 19.9479C23.2089 20.2362 27.7782 19.3625 29.9422 16.472C30.499 10.1091 26.8465 3.44751 26.8465 3.44751ZM10.3768 14.2051C8.69536 14.2051 7.70428 13.1038 7.70428 11.5318C7.70428 9.95976 8.69536 8.85846 10.3768 8.85846C12.0583 8.85846 12.8657 10.6841 12.8657 11.5318C12.8657 12.2266 12.0583 14.2051 10.3768 14.2051ZM19.471 14.2051C17.7895 14.2051 16.984 12.2266 16.984 11.5318C16.984 10.6841 17.7895 8.85846 19.471 8.85846C21.1525 8.85846 22.1454 9.95976 22.1454 11.5318C22.1454 13.1038 21.1525 14.2051 19.471 14.2051Z"
      fill="currentColor"
    />
  </svg>
);

export const TelegramSVG = (
  <svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.9494 0.496926C27.8483 0.202632 27.7277 0.125186 27.541 0.0516122C27.1326 -0.0994074 26.4402 0.129058 26.4402 0.129058C26.4402 0.129058 1.89912 8.91143 0.498775 9.88337C0.195367 10.0925 0.0942311 10.2164 0.0475529 10.3597C-0.193618 11.0489 0.561013 11.3548 0.561013 11.3548L6.88591 13.4072C6.88591 13.4072 7.12319 13.442 7.20487 13.3878C8.64412 12.4817 21.6829 4.2879 22.4336 4.01297C22.5542 3.97812 22.6398 4.01297 22.6165 4.09816C22.3169 5.15143 10.9897 15.1691 10.9897 15.1691C10.9897 15.1691 10.9469 15.2233 10.9197 15.2852L10.9041 15.2775L10.3129 21.5235C10.3129 21.5235 10.0639 23.4364 11.9855 21.5235C13.3431 20.1721 14.6539 19.0414 15.3113 18.4954C17.4857 19.9901 19.8274 21.6435 20.8388 22.5071C21.3445 22.9408 21.7685 23.0105 22.1185 22.9988C23.0755 22.964 23.3439 21.9146 23.3439 21.9146C23.3439 21.9146 27.8172 3.99748 27.965 1.59666C27.9806 1.36045 28 1.2133 28 1.05066C28 0.826072 27.9806 0.601478 27.9455 0.496926H27.9494Z"
      fill="currentColor"
    />
  </svg>
);

export const TwitterSVG = (
  <svg width="50" height="42" viewBox="0 0 50 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.724 42C34.592 42 44.912 25.8401 44.912 11.8263C44.912 11.3673 44.912 10.9104 44.882 10.4555C46.8897 8.95428 48.6227 7.09549 50 4.96617C48.1278 5.82379 46.1417 6.38622 44.108 6.63468C46.2495 5.30935 47.8522 3.22483 48.618 0.769062C46.6043 2.00433 44.4013 2.87488 42.104 3.34315C38.9242 -0.152247 33.8714 -1.00776 29.7791 1.25634C25.6868 3.52044 23.5725 8.34108 24.622 13.0151C16.3738 12.5877 8.68895 8.56023 3.48 1.93516C0.757245 6.78074 2.14798 12.9797 6.656 16.0916C5.02348 16.0416 3.42656 15.5863 2 14.7643C2 14.8077 2 14.8532 2 14.8986C2.00134 19.9467 5.4435 24.2947 10.23 25.2943C8.71974 25.72 7.13516 25.7823 5.598 25.4762C6.9419 29.7962 10.7931 32.7556 15.182 32.8408C11.5495 35.7921 7.06212 37.3942 2.442 37.3894C1.62581 37.3878 0.810408 37.3367 0 37.2364C4.69127 40.3486 10.1498 41.9994 15.724 41.9917"
      fill="currentColor"
    />
  </svg>
);

export const FacebookSVG = (
  <svg width="25" height="47" viewBox="0 0 25 47" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.227 47V25.5612H23.598L24.7015 17.206H16.227V11.8716C16.227 9.45252 16.915 7.80409 20.4682 7.80409L25 7.80201V0.329189C24.216 0.227549 21.526 0 18.3965 0C11.8626 0 7.38965 3.89364 7.38965 11.0443V17.206H0V25.5612H7.38965V47H16.227Z"
      fill="currentColor"
    />
  </svg>
);

export const LinkedinSVG = (
  <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.68736 0C8.58564 0 10.9012 2.5139 10.8705 5.60288C10.8552 8.69186 8.50896 11.2058 5.59535 11.2058C2.68174 11.2058 0.396851 8.69186 0.412186 5.60288C0.427521 2.5139 2.80442 0 5.68736 0Z"
      fill="currentColor"
    />
    <path
      d="M10.1238 14.9411L9.91566 45.5702H1.15918L1.38218 14.9411H10.1238Z"
      fill="currentColor"
    />
    <path
      d="M34.6414 14.1939C44.3098 14.1939 46.0293 20.5209 45.9807 28.7735L45.8509 45.5701H36.3285L36.4421 30.6992C36.4745 27.1392 36.4259 22.5598 31.543 22.5598C26.6602 22.5598 25.8004 26.4272 25.768 30.4241L25.6544 45.5701H16.0996L16.3267 14.9544H25.476L25.4435 19.1455H25.5895C26.8873 16.7506 30.0019 14.2101 34.6414 14.2101V14.1939Z"
      fill="currentColor"
    />
  </svg>
);

export const InstagramSVG = (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.3443 7.85822H36.376C37.9919 7.85822 39.3068 9.17319 39.2909 10.8209C39.2909 12.4369 37.9443 13.7518 36.3126 13.7518C34.6808 13.736 33.3818 12.4052 33.3976 10.7892C33.3976 9.15735 34.7284 7.85822 36.3443 7.85822Z"
      fill="currentColor"
    />
    <path
      d="M46.8601 11.8367C47.21 15.549 47.4382 33.0758 46.3428 37.1837C44.8823 42.5543 41.3678 45.7341 35.9364 46.6165C33.8977 46.9512 28.4207 47.149 22.9284 47.149C17.4361 47.149 11.7156 46.936 9.8291 46.4492C4.48897 45.0647 1.29402 41.5806 0.442028 36.1643C-0.181748 32.1782 -0.242604 13.7081 0.89845 9.69149C2.40464 4.473 5.88866 1.39971 11.1679 0.5325C13.5565 0.136928 18.2425 0 22.974 0C27.3709 0 31.8134 0.121714 34.4911 0.258643C37.7317 0.426 40.6832 1.47578 43.1022 3.77314C45.3995 5.96399 46.571 8.71778 46.8601 11.8215V11.8367ZM42.3263 35.3884C42.9957 31.2501 42.9957 16.1119 42.6154 12.2323C42.1894 8.09399 39.6638 5.35542 35.5561 4.71642C33.5326 4.41214 28.6337 4.27521 23.7652 4.27521C18.8967 4.27521 14.3933 4.39692 12.3394 4.62514C8.23162 5.09678 5.46266 7.63756 4.80846 11.7302C4.13904 16.0663 4.13904 32.2695 4.64111 35.5253C5.15838 38.9181 7.07535 41.2459 10.4529 42.1892C12.2786 42.7065 17.7556 42.889 23.1262 42.889C28.0707 42.889 32.924 42.7369 34.7497 42.5391C38.9031 42.0827 41.6417 39.5267 42.2959 35.4036"
      fill="currentColor"
    />
    <path
      d="M23.6757 11.1325C30.5348 11.1325 36.0627 16.7075 36.0158 23.5824C35.9688 30.4416 30.3469 36.0167 23.4722 36.0167C16.5974 36.0167 11.0852 30.4416 11.1321 23.5667C11.1791 16.6919 16.801 11.1168 23.6757 11.1325ZM23.4878 31.6161C27.9039 31.6161 31.5214 28.0612 31.5997 23.645C31.678 19.1819 28.1388 15.5643 23.6914 15.5174C23.6601 15.5174 23.6444 15.5174 23.6131 15.5174C19.197 15.5174 15.5796 19.0722 15.5013 23.4884C15.423 27.936 18.9621 31.5691 23.4095 31.6161C23.4408 31.6161 23.4565 31.6161 23.4878 31.6161Z"
      fill="currentColor"
    />
  </svg>
);

export const YoutubeSVG = (
  <svg width="54" height="38" viewBox="0 0 54 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M51.6677 5.05347C53.5712 10.0071 53.4885 28.0666 51.2042 32.8562C50.5752 34.1684 49.582 35.0542 48.324 35.7267C46.5363 36.6452 36.1742 37.0717 26.0107 37.0717C16.6584 37.0717 7.48807 36.7108 5.3362 36.0055C3.34986 35.3494 1.99252 34.0536 1.28075 32.0853C-0.424197 27.2956 -0.804913 7.21864 2.62153 3.24916C3.78023 1.90413 5.28654 1.1004 7.07425 0.919966C11.1463 0.477091 19.0089 0.263855 26.7722 0.263855C36.4225 0.263855 45.9073 0.591911 47.7115 1.24802C49.6151 1.92054 50.9724 3.16715 51.6842 5.03707L51.6677 5.05347ZM19.9358 26.6067C25.4314 23.769 30.9104 20.9806 36.4556 18.1429C30.96 15.2888 25.5141 12.4675 20.0682 9.62984C20.0186 15.3052 19.9855 20.915 19.9358 26.6067Z"
      fill="currentColor"
    />
  </svg>
);

export const MediumSVG = (
  <svg
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      height: "64px",
    }}
    version="1.1"
    viewBox="0 0 1151 1151"
  >
    <g transform="matrix(1,0,0,1,-246.226,-1.33631)">
      <path
        d="M883.45,576.26C883.45,739.93 751.67,872.61 589.12,872.61C426.57,872.61 294.78,739.93 294.78,576.26C294.78,412.59 426.56,279.9 589.12,279.9C751.68,279.9 883.45,412.59 883.45,576.26"
        style={{ fillRule: "nonzero", fill: "currentcolor" }}
      />
    </g>
    <g transform="matrix(1,0,0,1,-246.226,-1.33631)">
      <path
        d="M1206.34,576.26C1206.34,730.32 1140.45,855.26 1059.17,855.26C977.89,855.26 912,730.32 912,576.26C912,422.2 977.88,297.26 1059.16,297.26C1140.44,297.26 1206.33,422.16 1206.33,576.26"
        style={{ fillRule: "nonzero", fill: "currentcolor" }}
      />
    </g>
    <g transform="matrix(1,0,0,1,-246.226,-1.33631)">
      <path
        d="M1338.41,576.26C1338.41,714.26 1315.24,826.2 1286.65,826.2C1258.06,826.2 1234.9,714.29 1234.9,576.26C1234.9,438.23 1258.07,326.32 1286.65,326.32C1315.23,326.32 1338.41,438.22 1338.41,576.26"
        style={{ fillRule: "nonzero", fill: "currentcolor" }}
      />
    </g>
    <g transform="matrix(1,0,0,1,-246.226,-1.33631)">
      <path
        d="M1633.77,0L1337.48,0L1337.48,0.25L296.29,0.25L296.29,0L-0,0L-0,1150.07L119.51,1150.07L119.51,1150.51L1529.92,1150.51L1529.92,1150.07L1633.77,1150.07L1633.77,0ZM1337.48,296.54L1337.48,854.21L296.29,854.21L296.29,296.54L1337.48,296.54Z"
        style={{ fillRule: "nonzero", fill: "none" }}
      />
    </g>
  </svg>
);

export const MoonSVG = (
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.17084 24.3448C17.1033 24.3448 24.3444 17.1037 24.3444 8.17127C24.3444 5.87191 23.8646 3.68461 22.9996 1.70406C22.7933 1.23163 23.3129 0.749924 23.7234 1.06182C27.6108 4.01569 30.1209 8.68847 30.1209 13.9475C30.1209 22.8799 22.8797 30.1211 13.9473 30.1211C8.68855 30.1211 4.01597 27.6113 1.06208 23.7241C0.750162 23.3137 1.23184 22.794 1.70428 23.0003C3.68467 23.8651 5.87173 24.3448 8.17084 24.3448Z"
      fill="currentColor"
    />
    <path
      d="M9 4L9.2376 4.67278C9.66109 5.87193 10.7946 6.67376 12.0664 6.67376H13L12.4657 7.03093C11.3256 7.79298 10.8474 9.23104 11.3041 10.5241L11.4721 11L10.6672 10.4619C9.65806 9.7874 8.34194 9.7874 7.33284 10.4619L6.52786 11L6.69595 10.5241C7.15259 9.23105 6.67438 7.79298 5.53434 7.03093L5 6.67376H5.93362C7.20536 6.67376 8.33891 5.87193 8.7624 4.67278L9 4Z"
      fill="currentColor"
    />
    <path
      d="M14 14L14.021 14.0681C14.2892 14.936 15.0916 15.5279 16 15.5279C15.2574 16.0952 14.9473 17.0654 15.2232 17.9583L15.2361 18C14.5063 17.4425 13.4937 17.4425 12.7639 18L12.7768 17.9583C13.0527 17.0654 12.7426 16.0952 12 15.5279C12.9084 15.5279 13.7108 14.936 13.979 14.0681L14 14Z"
      fill="currentColor"
    />
    <path
      d="M3.5 13L3.51579 13.0511C3.71693 13.702 4.31872 14.1459 5 14.1459C4.44302 14.5714 4.21044 15.299 4.41738 15.9687L4.42705 16C3.87973 15.5819 3.12027 15.5819 2.57295 16L2.58262 15.9687C2.78956 15.299 2.55698 14.5714 2 14.1459C2.68128 14.1459 3.28307 13.702 3.48422 13.0511L3.5 13Z"
      fill="currentColor"
    />
  </svg>
);

export const SunSVG = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="9" fill="currentColor" />
    <path
      d="M16.0001 0L17.3306 3.19335C17.7262 4.14281 17.0286 5.18919 16.0001 5.18919C14.9715 5.18919 14.2739 4.14281 14.6695 3.19335L16.0001 0Z"
      fill="currentColor"
    />
    <path
      d="M24.0024 1.77057L23.4315 5.53028C23.2773 6.54598 22.152 7.09093 21.2595 6.58215C20.367 6.07337 20.2626 4.82747 21.0581 4.17728L24.0024 1.77057Z"
      fill="currentColor"
    />
    <path
      d="M30.266 8.21565L27.8398 11.1439C27.1843 11.935 25.9392 11.8223 25.4363 10.9264C24.9335 10.0306 25.4859 8.90895 26.5026 8.76149L30.266 8.21565Z"
      fill="currentColor"
    />
    <path
      d="M32 16.0001L28.8067 17.3306C27.8572 17.7262 26.8108 17.0286 26.8108 16.0001C26.8108 14.9715 27.8572 14.2739 28.8067 14.6695L32 16.0001Z"
      fill="currentColor"
    />
    <path
      d="M7.65583 2.32233L8.2267 6.08203C8.38092 7.09774 9.50617 7.64269 10.3987 7.13391C11.2912 6.62513 11.3956 5.37923 10.6002 4.72904L7.65583 2.32233Z"
      fill="currentColor"
    />
    <path
      d="M1.7574 8.21565L4.18364 11.1439C4.83911 11.935 6.08429 11.8223 6.58712 10.9264C7.08995 10.0306 6.53753 8.90895 5.52082 8.76149L1.7574 8.21565Z"
      fill="currentColor"
    />
    <path
      d="M16.0001 32L17.3306 28.8067C17.7262 27.8572 17.0286 26.8108 16.0001 26.8108C14.9715 26.8108 14.2739 27.8572 14.6695 28.8067L16.0001 32Z"
      fill="currentColor"
    />
    <path
      d="M24.2582 30.0732L23.6874 26.3135C23.5331 25.2978 22.4079 24.7528 21.5154 25.2616C20.6229 25.7704 20.5185 27.0163 21.3139 27.6665L24.2582 30.0732Z"
      fill="currentColor"
    />
    <path
      d="M29.7992 24.2223L27.373 21.2941C26.7175 20.503 25.4724 20.6157 24.9695 21.5116C24.4667 22.4074 25.0191 23.529 26.0358 23.6765L29.7992 24.2223Z"
      fill="currentColor"
    />
    <path
      d="M7.74177 30.0732L8.31263 26.3135C8.46686 25.2978 9.59211 24.7528 10.4846 25.2616C11.3771 25.7704 11.4815 27.0163 10.6861 27.6665L7.74177 30.0732Z"
      fill="currentColor"
    />
    <path
      d="M1.7574 23.9679L4.18364 21.0397C4.83911 20.2486 6.08429 20.3613 6.58712 21.2572C7.08995 22.153 6.53753 23.2746 5.52082 23.4221L1.7574 23.9679Z"
      fill="currentColor"
    />
    <path
      d="M9.45111e-08 16.0001L3.19335 17.3306C4.14281 17.7262 5.18919 17.0286 5.18919 16.0001C5.18919 14.9715 4.14281 14.2739 3.19335 14.6695L9.45111e-08 16.0001Z"
      fill="currentColor"
    />
  </svg>
);

export const LeftSVG = (
  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M-3.0598e-07 7L10.5 0.937823L10.5 13.0622L-3.0598e-07 7Z" fill="currentColor" />
  </svg>
);

export const RightSVG = (
  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 7L0.5 13.0622L0.500001 0.937822L11 7Z" fill="currentColor" />
  </svg>
);
